import React, { useId } from "react";
import PropTypes from "prop-types";

const SegmentedControl = ({ id, label, name, onChange, options, value }) => {
  const generatedName = useId();
  const groupName = name || generatedName;
  return (
    <fieldset className="wsm-segmented" id={id} tabIndex="-1">
      {label && <legend className="wsm-segmented__legend">{label}</legend>}
      <div className="wsm-segmented__group">
        {options.map((option) => (
          <label className="wsm-segmented__option" key={option.value}>
            <input checked={value === option.value} disabled={option.disabled} name={groupName} onChange={() => onChange(option.value)} type="radio" value={option.value} />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};

SegmentedControl.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ disabled: PropTypes.bool, label: PropTypes.string.isRequired, value: PropTypes.string.isRequired })).isRequired,
  value: PropTypes.string.isRequired,
};
export default SegmentedControl;
